module.exports = __webpack_public_path__ + "img/progress-dote_empty_light.f38b68f5.svg";